import React, { Fragment, useEffect, useState } from "react";

export default function TypeWriterText({ text = "", speed = 30, onComplete }) {
    const [displayedText, setDisplayedText] = useState("");

    useEffect(() => {
        setDisplayedText("");
        const fullText = String(text);

        if (fullText.length === 0) {
            if (onComplete) onComplete();
            return;
        }

        let i = 0;
        let cancelled = false;
        let timerId = null;

        const tick = () => {
            if (cancelled) return;

            const ch = fullText.charAt(i);
            if (ch === "") {
                if (onComplete) onComplete();
                return;
            }

            setDisplayedText((prev) => prev + ch);
            i += 1;

            if (i >= fullText.length) {
                if (onComplete) onComplete();
                return;
            }

            timerId = setTimeout(tick, speed);
        };

        timerId = setTimeout(tick, speed);

        return () => {
            cancelled = true;
            if (timerId) clearTimeout(timerId);
        };
    }, [text, speed, onComplete]);

    return (
        <Fragment>
            {displayedText}
            <span className="cursor ms-1 mb-2">▍</span>
        </Fragment>
    );
}
